import { useCurrentUser } from '@/stores/user.store'
import { authActions } from '@/stores/auth.store'

/**
 * Custom hook for user display information and common actions
 * Centralizes logic for displaying user name, initials, and logout
 */
export function useUserDisplay() {
  const { user, isLoading } = useCurrentUser()

  // Generate display name from first and last name
  const displayName = user?.firstName && user?.lastName
    ? `${user.firstName} ${user.lastName}`.trim()
    : user?.firstName || user?.lastName || user?.email || 'User'

  // Generate initials from first and last name
  const initials = user?.firstName && user?.lastName
    ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase()
    : user?.firstName
      ? user.firstName.charAt(0).toUpperCase()
      : user?.email
        ? user.email.charAt(0).toUpperCase()
        : 'U'

  const email = user?.email || ''

  // Handle logout
  const handleLogout = async () => {
    try {
      await authActions.signOut()
    } catch (error) {
      console.error('Failed to sign out:', error)
    }
  }

  return {
    user,
    isLoading,
    displayName,
    initials,
    email,
    handleLogout,
  }
}
